import type { OptionValueType, TriggerFieldInputProps } from '../../types/types';
import ExoField from './ExoField';
import TimeOffset from './TimeOffset';

const NumberField = ({
    option,
    value,
    onChange,
    type,
    showValidation = false,
    validationMessage = null,
}: TriggerFieldInputProps) => {
    const onInputChange = (id: string, newValue: OptionValueType) => {
        if (typeof newValue === 'string') {
            onChange(id, Number.parseFloat(newValue));
        } else {
            onChange(id, newValue);
        }
    };

    return option.id === 'timeoffset' ? (
        <TimeOffset option={option} value={value as number} onChange={onChange} />
    ) : (
        <ExoField
            option={option}
            value={value}
            onChange={onInputChange}
            type={type}
            showValidation={showValidation}
            validationMessage={validationMessage}
        />
    );
};

export default NumberField;
